export enum BodyLinkFormat {
  Card = 'card',
  Hovercard = 'hovercard',
}
